import React from 'react';
import { useNavigate } from 'react-router-dom';

const Breadcrumb = () => {
  const navigate = useNavigate();

  const steps = [
    { number: 1, label: 'Home', path: '/search-flight' },
    { number: 2, label: 'Flights', path: '/flight-list' },
    { number: 3, label: 'Details', active: true },
    { number: 4, label: 'Passengers' },
    { number: 5, label: 'Payment' }
  ];

  return (
    <div className="bg-white shadow-sm">
      <div className="w-[86%] mx-auto">
        <div className="flex justify-center items-center gap-8 py-4">
          {steps.map((step) => (
            <button
              key={step.number}
              onClick={() => step.path && navigate(step.path)}
              className="flex flex-col items-center"
              disabled={!step.path}
            >
              <div className="w-30 h-10 border-b-3 border-gray-400 px-2 flex items-center">
                <span className={`text-2xl mr-2 ${step.active ? 'text-jet-yellow' : ''}`}>
                  {step.number}
                </span>
                <span className="text-xs text-gray-600">{step.label}</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
